import axios from 'axios';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../../../providers/auth_provider';

const DeleteConfirmation = ({ music, fetchUploadedMusic }) => {
    const { token } = useAuth();
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

 
    // Handle delete action
    const handleDelete = () => {
        setShowModal(true); // Show modal for confirmation
    };

    // Confirm delete action
    const confirmDelete = async () => {
        try {
            setLoading(true);
            await axios.delete(`${process.env.REACT_APP_API_URL}/music/delete/${music.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`,
                },
            });
            fetchUploadedMusic(); // Refresh the frequencies list
            setShowModal(false); // Close modal after confirmation
            toast.success('Music deleted successfully');
        } catch (error) {
            toast.error(error.response?.data?.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <button className="btn text-danger" onClick={handleDelete}>
               Delete
            </button>

            {/* Confirmation Modal */}
            {showModal && (
                <div className="modal show" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Deletion</h5>
                                <button
                                    type="button"
                                    className="btn"
                                    style={{ marginLeft: "auto" }}
                                    onClick={() => setShowModal(false)}
                                >
                                    <i className="ri-close-large-line"></i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>Are you sure you want to delete this music?</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                    Cancel
                                </button>
                                <button type="button" className="btn btn-primary" onClick={confirmDelete}>
                                    {loading ? "Please wait..." : "Confirm"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default DeleteConfirmation;
